import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerManpowerAllocation } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerManpowerAllocationSlice = createSlice({
  name: "ProjectManagerManpowerAllocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerManpowerAllocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerManpowerAllocation.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerManpowerAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch ProjectManager Manpower Allocation List";
      });
  },
});

export default ProjectManagerManpowerAllocationSlice.reducer;
